// Auto-generated file. Do not modify.
export const APP_VERSION = '1.3.2.97';
export const BUILD_NUMBER = 97;
export const VERSION = '1.3.2';
export const FULL_VERSION = '1.3.2.97';
export const GIT_HASH = '617d8a4';
export const GIT_BRANCH = 'master';
export const BUILD_INFO = '1.3.2.97 (617d8a4)';
export const RELEASE_NAME = '';
